var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMyLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mypage / Heart_01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 8.03367C10 3.33923 3 3.83923 3 9.83926C3 15.8393 12 20.8395 12 20.8395C12 20.8395 21 15.8393 21 9.83926C21 3.83923 14 3.33923 12 8.03367Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMyLike);
export default __webpack_public_path__ + "static/media/ic_my_like.bbc8e41559aa11777941e88f7b8917de.svg";
export { ForwardRef as ReactComponent };